<template>
    <div id="CodeExchange">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full">
                        <img src="./img/icon_img21.png"
                             @click="close"
                             class="close" />
                        <div class="title">激活码兑换</div>
                        <input type="text"
                               class="code"
                               v-model="card_no"
                               placeholder="请输入激活码">
                        <button class="btn"
                                @click="active"
                                :disabled='btn_dsiabled'>激活</button>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data () {
        return {
            card_no: '',
            btn_dsiabled: false,
        }
    },
    created () {

    },
    methods: {
        fetchProfile(){
            this.$http.get(`/front/user/profile/`).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    localStorage.setItem("userinfo", JSON.stringify(res.data));
                    localStorage.setItem("invite_code", res.data.invite_code);
                }
            }).finally(() => {

            })
        },
        close () {
            this.$store.commit('setShowCodeExchange', false)
        },
        active () {
            if (this.btn_dsiabled) {
                return
            }
            if (!this.card_no.length) {
                this.$message({
                    message: '请输入激活码',
                    type: 'warning'
                });
                return
            }
            this.btn_dsiabled = true
            this.$http.post('/front/aivideo/cardpwd/bind/',{card_no:this.card_no}).then(res =>{
                if(res.status=='200'){
                    this.$message({
                        message: "激活码兑换成功",
                        type: 'success'
                    });
                    this.close()
                    this.fetchProfile()
                }else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }).catch(res => {
                this.$message({
                    message: res.result,
                    type: 'error'
                });
            }).finally(()=>{
                this.btn_dsiabled = false
            })
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#CodeExchange {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 300px;
            padding: 0;
            background-color: #1e1f22;
            border: 2px solid #5865f2;
            border-radius: 5px;
            .full {
                position: relative;
                .close {
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    width: 28px;
                    height: 28px;
                    padding: 6px;
                    cursor: pointer;
                }
                .title {
                    font-size: 22px;
                    padding: 30px 0;
                    text-align: center;
                    color: #fff;
                }
                .code {
                    width: 220px;
                    display: block;
                    margin: 0 40px 20px 40px;
                    border-radius: 4px;
                    background: #fff;
                    padding-left: 10px;
                    line-height: 36px;
                    border: none;
                }
                .btn {
                    display: block;
                    width: 220px;
                    cursor: pointer;
                    background-color: #5865f2;
                    color: #fff;
                    line-height: 36px;
                    text-align: center;
                    font-size: 14px;
                    border-radius: 999px;
                    margin: 40px auto;
                    border: 0;
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>